import { compareMoney } from 'lib/maths/mathUtils'

/**
 * Compare the item total cost with the budget at the cent precision
 * This rounds up the IEEE-754 JS double precision problem
 */
export function isOverBudget(total: number, budget: number): boolean {
  return compareMoney(total, budget) > 0
}

export function isWithinBudget(total: number, budget: number): boolean {
  return compareMoney(total, budget) <= 0
}

/** A persisted trip request item's policy budget, null when no policy was applied to it */
export function getApplicableItemBudget(item: App.BusinessTraveller.TripRequestItem): number | null {
  return item.budget > 0 ? item.budget : null
}

/** Whether a persisted trip request item exceeds its policy budget, false when no policy was applied */
export function isItemOutOfPolicy(item: App.BusinessTraveller.TripRequestItem): boolean {
  const applicableBudget = getApplicableItemBudget(item)
  return applicableBudget !== null && isOverBudget(item.approvedCost, applicableBudget)
}
